export default __webpack_public_path__ + "static/media/icar_neww.ab0198a1.svg";